import { z } from "zod";
import { MessageType, messageMetadataSchema } from "./websocket";
/**
 * Message schema for database
 */
export const messageSchema = z.object({
    id: z.string().uuid(),
    session_id: z.string().uuid(),
    type: z.nativeEnum(MessageType),
    content: z.string(),
    sender_id: z.string(),
    sender_name: z.string().optional(),
    metadata: messageMetadataSchema,
    created_at: z.string().datetime(),
});
